import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateFn, CanDeactivateFn, Router } from '@angular/router';
import { httpGetCustomerGetInitialAdminLoginComplete } from '@zvoove-market/api';
import { ADMIN_ROLE, AuthService, BUSINESS_EXECUTIVE_ROLE } from '@zvoove-market/shared';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const firstAdminLoginGuard = (): CanActivateFn => () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const http = inject(HttpClient);
  const ctx = auth.$context;
  if (!ctx().mandant?.roles.includes(ADMIN_ROLE) && !ctx().mandant?.roles.includes(BUSINESS_EXECUTIVE_ROLE)) {
    return of(true);
  } else {
    return httpGetCustomerGetInitialAdminLoginComplete(http).pipe(
      catchError(() => of(true)),
      map((initialLoginComplete) => initialLoginComplete || router.parseUrl('/customer/detail'))
    );
  }
};

export const firstAdminLoginPreventLeaveGuard = (): CanDeactivateFn<unknown> => () => {
  const auth = inject(AuthService);
  const http = inject(HttpClient);
  const ctx = auth.$context;
  if (!ctx().mandant?.roles.includes(ADMIN_ROLE) && !ctx().mandant?.roles.includes(BUSINESS_EXECUTIVE_ROLE)) {
    return of(true);
  } else {
    return httpGetCustomerGetInitialAdminLoginComplete(http).pipe(
      catchError(() => of(true)),
      map((initialLoginComplete) => initialLoginComplete)
    );
  }
};
